// PDP color swatch AJAX handler

// Re-executes inline scripts within an element.
function executeScripts(element) {
  element.querySelectorAll('script:not([src])').forEach((oldScript) => {
    const newScript = document.createElement('script');
    Array.from(oldScript.attributes).forEach((attr) => {
      newScript.setAttribute(attr.name, attr.value);
    });
    newScript.textContent = oldScript.textContent;
    oldScript.parentNode.replaceChild(newScript, oldScript);
  });
}

document.addEventListener('click', async (event) => {
  const swatchButton = event.target.closest('.color_wrapper-PDP .pdp-swatch-button[data-product-url]');
  if (!swatchButton) return;

  // Skip if inside quick-add modal (handled by quick-add.js)
  if (swatchButton.closest('quick-add-modal')) return;

  // Skip if this swatch is already selected (active)
  if (swatchButton.classList.contains('active')) return;

  const productUrl = swatchButton.dataset.productUrl;

  const section = document.querySelector('section[id^="MainProduct-"]');
  if (!section) {
    window.location.href = productUrl;
    return;
  }

  // Show loading state
  section.classList.add('main-product-loading');

  const sectionId = section.id.replace('MainProduct-', '');

  try {
    const response = await fetch(`${productUrl}?section_id=${sectionId}`);
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newSection = doc.querySelector('section[id^="MainProduct-"]');

    if (!newSection) throw new Error('Main product section not found');

    section.replaceWith(newSection);

    // Re-execute inline scripts
    executeScripts(newSection);

    // Reinitialize Shopify payment buttons
    window.Shopify?.PaymentButton?.init();

  } catch (error) {
    console.error('Color swatch AJAX error:', error);
    window.location.href = productUrl;
  }
});
